// extracted by mini-css-extract-plugin
export default {"account-menu__user-container":"account-menu_account-menu__user-container__Uz8IF","account-menu__user-container__name":"account-menu_account-menu__user-container__name__5LQEr"};